/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */
/*
 * --------------------------------------------------------------------------------
 * This file contains the combine reducers function that is responsible for
 * combining reducers stored within a reducer registry into a state useable by the
 * redux store.
 * --------------------------------------------------------------------------------
 */
/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */
/*
 * Used for typing:
 *      - Reducer
 */
import { combineReducers as reduxCombineReducers } from 'redux';
/*
 * ---------------------------------------------------------------------------------
 * Functions
 * ---------------------------------------------------------------------------------
 */
/**
 * This function is used to combine reducers while creating dummy reducers for any
 * property in the preload state that does not yet have a reducer loaded.
 * @param reducers reducers to be combined.
 * @param preloadState preloaded state.
 * @returns the combined reducer.
 */
export var combineReducers = function (reducers, preloadState) {
    var reducerNames = Object.keys(reducers);
    // Check if preloaded state references any reducers that have not yet been
    // registered and create a dummy reducer for the time being.
    if (preloadState) {
        Object.keys(preloadState).forEach(function (item) {
            if (reducerNames.indexOf(item) === -1) {
                reducers[item] = function (state) {
                    if (state === void 0) { state = null; }
                    return state;
                };
            }
        });
    }
    // If no reducers are registered, create a placeholder reducer.
    if (Object.keys(reducers).length === 0) {
        return function (state) {
            if (state === void 0) { state = null; }
            return state;
        };
    }
    return reduxCombineReducers(reducers);
};
/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */
export default combineReducers;
//# sourceMappingURL=combineReducers.js.map